/* eslint-disable import/no-anonymous-default-export */
import {
  LIST_CUSTOMERS,
  ADD_CUSTOMER,
  DELETE_CUSTOMER,
  UPDATE_CUSTOMER
} from '../types';



export default (state, action) => {
  //console.log(action)
  switch (action.type) {

    case LIST_CUSTOMERS:
      return {
        ...state,
        list: action.payload,
        loading:false,
        message:null
      }
    case ADD_CUSTOMER:
    case DELETE_CUSTOMER:
    case UPDATE_CUSTOMER:
      return {
        ...state,
        loading:true
      }

    default:
      console.log('default')
      return state;

  }
}